import React, { MouseEventHandler } from 'react'

import TinyPopover from 'components/Utils/TinyPopover'
import EmojiPicker from 'components/Utils/Emoji/Picker'

export type IconPickerPopoverProps = {
  isEditingIcon: boolean
  onClickOutside: MouseEventHandler
  iconShape?: string
  iconColor?: string
  onChange: (value: { iconShape: string; iconColor?: string }) => void
}

export default class IconPickerPopover extends React.Component<
  IconPickerPopoverProps
> {
  onChange = (emoji: { id: string }) => {
    const { iconColor, onChange } = this.props
    onChange({
      iconShape: emoji.id,
      iconColor,
    })
  }

  renderContent = () => {
    const { onClickOutside } = this.props
    return (
      <div
        className="zindex-large radius-normal scroll-y background-shade-100 border-none shadow-hovering"
        contentEditable={false}
      >
        <EmojiPicker onClick={this.onChange} onClose={onClickOutside} />
      </div>
    )
  }

  render() {
    const { isEditingIcon, onClickOutside } = this.props

    return (
      <TinyPopover
        isOpen={isEditingIcon}
        align={'start'}
        onClickOutside={onClickOutside}
        containerStyle={{
          overflow: 'visible',
          marginTop: '8px',
          marginLeft: '19px',
        }}
        position="bottom"
        content={this.renderContent}
      >
        {this.props.children}
      </TinyPopover>
    )
  }
}
